// 前端配置文件
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/agent';
const mcpUrl = import.meta.env.VITE_MCP_URL || 'http://localhost:9000';
const frontendUrl = import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173';
const testVideoUrl = import.meta.env.VITE_TEST_VIDEO_URL || 'http://localhost:8000/MP4/1.mp4';

const inferMediaBaseUrl = (videoUrl) => {
  const normalizedUrl = (videoUrl || '').replace(/\/+$/, '');
  return normalizedUrl.replace(/\/[^/]+$/, '');
};

const mediaBaseUrl = inferMediaBaseUrl(testVideoUrl);

const buildMediaUrl = (fileName) => {
  if (!fileName) {
    return testVideoUrl;
  }
  return `${mediaBaseUrl}/${encodeURIComponent(fileName)}`;
};

const config = {
  apiUrl,
  mcpUrl,
  frontendUrl,
  localPlayerEntry: import.meta.env.VITE_LOCALPLAYER_ENTRY || 'file:////data/apps/app.tvos.localplayer.app/index.html',
  localPlayerStorageKey: import.meta.env.VITE_LOCALPLAYER_STORAGE_KEY || 'InputMediaURL',
  mediaBaseUrl,
  testVideoUrl,
  testVideoFallback: import.meta.env.VITE_TEST_VIDEO_FALLBACK || '/videos/test.mp4',
  buildMediaUrl,
};

export default config;